import api from './api';

const categoryService = {
  // Get all categories with pagination and filtering
  getAllCategories: async (params = {}) => {
    const response = await api.get('/categories', { params });
    return response.data;
  },

  // Get categories for dropdown/select
  getCategoriesForSelect: async () => {
    const response = await api.get('/categories/select');
    return response.data;
  },

  // Get category by ID
  getCategoryById: async (id) => {
    const response = await api.get(`/categories/${id}`);
    return response.data;
  },

  // Create new category
  createCategory: async (categoryData) => {
    const response = await api.post('/categories', categoryData);
    return response.data;
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    const response = await api.put(`/categories/${id}`, categoryData);
    return response.data;
  },

  // Delete category
  deleteCategory: async (id) => {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
  },

  // Add subcategory to category
  addSubcategory: async (categoryId, subcategoryData) => {
    const response = await api.post(`/categories/${categoryId}/subcategories`, subcategoryData);
    return response.data;
  },

  // Update subcategory
  updateSubcategory: async (categoryId, subcategoryId, subcategoryData) => {
    const response = await api.put(`/categories/${categoryId}/subcategories/${subcategoryId}`, subcategoryData);
    return response.data;
  },

  // Delete subcategory
  deleteSubcategory: async (categoryId, subcategoryId) => {
    const response = await api.delete(`/categories/${categoryId}/subcategories/${subcategoryId}`);
    return response.data;
  }
};

export default categoryService; 